import React from 'react'
import StarFilter from './StarFilter'
import FlightFilter from './FlightFilter'
import PriceFilter from './PriceFilter'
import { useSelector } from 'react-redux'

const FilterContainer = ({ packageResult, handleFilterChange, filters }) => {
    const lang = useSelector((state) => state.culture.language);


    return (
        <div className="Col_Filter">
            <div className="filter__Col Filter anim">
                <div className="Filter_Head">
                    <h2>
                        <i className="htlFiltericon" />
                        <span>{lang.filter}</span>
                    </h2>
                </div>
                <div className="filterFullBox">
                    <span className="filterClose" />

                    <StarFilter packageResult={packageResult} filters={filters} handleFilterChange={handleFilterChange} />

                    <FlightFilter
                        handleFilterChange={handleFilterChange}
                        filters={filters} />

                    <PriceFilter packageResult={packageResult} handleFilterChange={handleFilterChange} filters={filters}  />

                    {/* <div className="Filterbox">
                        <div className="Filterhead d-flex justify-content-between">
                            <div className="FilterTitle d-flex">Transfer</div>
                            <div>
                                {" "}
                                <span className="filter_clear">
                                    <a href="#">Clear</a>
                                </span>{" "}
                            </div>
                        </div>
                        <ul className="FilterContent operatedBy td-checkbox">
                            <li className="filt_active">
                                <input type="checkbox" id="opby1" />
                                <label htmlFor="opby1">With Transfer</label>
                            </li>
                            <li>
                                <input type="checkbox" id="opby2" />
                                <label htmlFor="opby2">Without Transfer</label>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default FilterContainer